import { createFileRoute } from "@tanstack/react-router";
import { trpc } from "~/utils/trpc.client";
import { ReportTypeOverview } from "~/app/(new)/[teamId]/report-types/[reportTypeId]/ReportTypeOverview";
import { ReportTypeDefinition } from "~/app/(new)/[teamId]/report-types/[reportTypeId]/ReportTypeDefinition";
import { ReportTypeExportTemplate } from "~/app/(new)/[teamId]/report-types/[reportTypeId]/ReportTypeExportTemplate";

/**
 * Detailed view of a report type (was
 * (new)/[teamId]/report-types/[reportTypeId]/page.tsx).
 */
export const Route = createFileRoute(
  "/_authed/$teamId/report-types/$reportTypeId",
)({
  component: ReportTypePage,
});

function ReportTypePage() {
  const { reportTypeId } = Route.useParams();

  const reportTypeQuery = trpc.reportTypes.getReportType.useQuery({
    id: reportTypeId,
  });

  if (reportTypeQuery.isLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <span className="loading loading-spinner loading-lg"></span>
      </div>
    );
  }

  if (!reportTypeQuery.data) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="text-error">Report type not found</div>
      </div>
    );
  }

  const reportType = reportTypeQuery.data;

  return (
    <div className="m-auto flex h-full w-full max-w-[800px] flex-col gap-4 p-4">
      <ReportTypeOverview reportType={reportType} />
      <ReportTypeDefinition reportType={reportType} />
      <ReportTypeExportTemplate reportType={reportType} />
    </div>
  );
}
